<template>
  <v-card>
    <NotificationBar
      v-for="notification in notifications"
      :key="notification.id"
      :notification="notification"
    />
  </v-card>
</template>

<script>
// Pinia's mapState, not Vuex's. The notification module has moved, and Vuex's
// helper resolves the namespace through `$store._modulesNamespaceMap`, which no
// longer carries it; Pinia's takes the store itself instead of a namespace
// string.
import { mapState } from 'pinia'
import { useNotificationStore } from '~/stores/notification'

export default {
  computed: mapState(useNotificationStore, ['notifications']),
}
</script>
